/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filterModel: { items: [], logicOperator: 'and', quickFilterValues: [] },
    sortModel: [],
    columnVisibilityModel: { id: false },
    name: '',
};

const filterViewSlice = createSlice({
    name: 'filterViewData',
    initialState: initialState,
    reducers: {
        setFormData: (state, action) => {
            return action.payload;
        },
        updateFilterView: (state, action) => {
            return { ...state, ...action.payload };
        },
        resetFormData: (state) => {
            return initialState;
        },
    },
});

export const { setFormData, updateFilterView, resetFormData } = filterViewSlice.actions;
export default filterViewSlice.reducer;
